import PageHeader from "../components/PageHeader";
import { useLang } from "../i18n/LanguageProvider";

export default function Privacy() {
  const { t } = useLang();
  return (
    <>
      <PageHeader
        eyebrow={t("page.privacy.eyebrow")}
        title={t("page.privacy.title")}
        lede={t("page.privacy.lede")}
      />
      <section className="pb-24">
        <div className="max-w-3xl mx-auto px-6 lg:px-12 space-y-10 text-white/85 leading-relaxed">
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">1. Scope</h2>
            <p>
              This policy explains how Bonworld Family Office Pte. Ltd. ("Bonworld", "we")
              collects, uses, discloses and safeguards personal data provided through this
              website and in the course of any subsequent engagement.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">2. Data we collect</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Identifying information you voluntarily provide (name, email, phone, message).</li>
              <li>Technical data such as IP address, device type, and browser, collected via server logs.</li>
              <li>Data required for regulatory KYC/AML checks in the event a formal engagement is opened.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">3. Purposes of use</h2>
            <ul className="list-disc pl-6 space-y-2">
              <li>Responding to enquiries submitted through this website.</li>
              <li>Assessing whether Bonworld is the appropriate steward for the enquirer.</li>
              <li>Meeting legal, regulatory and contractual obligations.</li>
              <li>Improving the security and functioning of this website.</li>
            </ul>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">4. Legal bases</h2>
            <p>
              We process personal data on the basis of your consent, our legitimate interest in
              operating a discreet enquiry channel, and legal obligation where applicable.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">5. Disclosure</h2>
            <p>
              We do not sell personal data. We may share data with trusted service providers under
              confidentiality obligations, with regulators when legally required, and with
              professional advisors (legal, tax, audit) in the ordinary course of our engagement.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">6. Retention</h2>
            <p>
              Enquiry data is retained for the shorter of (i) the period necessary to answer your
              enquiry and any follow-up correspondence and (ii) the period required by law.
              Engagement-related data is retained for the duration of the engagement and any
              applicable statutory record-keeping period thereafter.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">7. Security</h2>
            <p>
              We apply administrative, technical and physical safeguards commensurate with the
              sensitivity of the data we hold. Transport is encrypted; access is strictly on a
              need-to-know basis; sensitive correspondence is available over encrypted channels.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">8. Your rights</h2>
            <p>
              You may request access to, correction of, or deletion of your personal data. You may
              withdraw consent at any time. Requests should be addressed to
              <a href="mailto:office@bonworldsingapore.com" className="text-gold hover:underline"> office@bonworldsingapore.com</a>.
            </p>
          </div>
          <div>
            <h2 className="font-serif-display text-2xl text-gold mb-3">9. Updates</h2>
            <p>
              This policy may be updated to reflect changes in law or practice. The version in
              force is the one published on this page.
            </p>
          </div>
        </div>
      </section>
    </>
  );
}
